
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("1MitM", function(module, exports) {
/* RecommendedSpaceBanner.tsx generated by @compiled/babel-plugin v3.0.2 */ 
var $cozmU = parcelRequire("cozmU");


var $iMnC5 = parcelRequire("iMnC5");


var $kLzei = parcelRequire("kLzei");


var $6M71K = parcelRequire("6M71K");


var $jmjWc = parcelRequire("jmjWc");


const $0b66dff4593ca6c7$export$a43cede55ed7d0d9 = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "nrGSh",
    name: "RecommendedPageBanner",
    loader: ()=>(parcelRequire("hnPr4")).then((module)=>module.RecommendedPageBanner)
});






const $bbb6457c855f524f$export$1a5da6c4c57b98ac = (0, $jmjWc.LoadablePaint)({
    __loadable_id__: "EThSJ",
    name: "RecommendedPageBannerNoContent",
    loader: ()=>(parcelRequire("fUsH5")).then((module)=>module.RecommendedPageBannerNoContent)
});



var $6mKj3 = parcelRequire("6mKj3");


var $dBcar = parcelRequire("dBcar");


var $ivb8S = parcelRequire("ivb8S");

const $0d669b05ee2164f6$var$styles = {
    wrapper: "_39xV02N91d _1wydGW5zaO"
};
const $0d669b05ee2164f6$var$parseTrendingPages = (rawValue)=>{
    if (typeof rawValue !== 'string' || !rawValue) return null;
    try {
        const parsed = JSON.parse(rawValue);
        if (parsed && typeof parsed === 'object') return parsed;
    } catch  {}
    return null;
};
const $0d669b05ee2164f6$export$8909129f89f5f935 = ({ spaceKey: spaceKey })=>{
    const [isDismissed, setIsDismissed] = (0, $cozmU.useState)(false);
    const { data: data, loading: loading } = (0, $ivb8S.useGetOnboardingState)([
        (0, $dBcar.CROSS_JOIN_NTH_USER_ONBOARDING).TRENDING_PAGES,
        (0, $dBcar.CROSS_JOIN_NTH_USER_ONBOARDING).DISMISSED
    ], // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
    !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc_activation_cross_join_nth_user_onboarding_exp', 'cohort', 'experiment'));
    const { setOnboardingState: setOnboardingState } = (0, $ivb8S.useSetOnboardingState)();
    const state = (0, $ivb8S.deserializeState)(data);
    const trendingPages = $0d669b05ee2164f6$var$parseTrendingPages(state?.trendingPages);
    const isBannerDismissed = state?.dismissed === true;
    const handleDismiss = ()=>{
        setIsDismissed(true);
        setOnboardingState({
            key: (0, $dBcar.CROSS_JOIN_NTH_USER_ONBOARDING).DISMISSED,
            value: 'true'
        });
    };
    if (loading || isDismissed || isBannerDismissed || !trendingPages || trendingPages.spaceKey !== spaceKey || // eslint-disable-next-line confluence-feature-gating/no-exposure-recommendation
    !(0, $6mKj3.UNSAFE_expValEqualsNoExposure)('cc_activation_cross_join_nth_user_onboarding_exp', 'cohort', 'experiment')) return null;
    const pageIds = trendingPages.pageIds ?? [];
    const hasContent = pageIds.length > 0;
    if (hasContent) return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0d669b05ee2164f6$var$styles.wrapper,
        testId: "recommended-space-banner-with-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6M71K.ConfluenceSmartCardProvider), (0, $kLzei.getSmartCardRenderers)(), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $0b66dff4593ca6c7$export$a43cede55ed7d0d9), {
        spaceKey: spaceKey,
        pageIds: pageIds,
        onDismiss: handleDismiss
    })));
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $iMnC5.Box), {
        xcss: $0d669b05ee2164f6$var$styles.wrapper,
        testId: "recommended-space-banner-no-content"
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $bbb6457c855f524f$export$1a5da6c4c57b98ac), {
        spaceKey: spaceKey,
        onDismiss: handleDismiss
    }));
};
module.exports["RecommendedSpaceBanner"] = $0d669b05ee2164f6$export$8909129f89f5f935;

});

parcelRegister("hnPr4", function(module, exports) {

let $ca7c7bb6d94e451f$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $ca7c7bb6d94e451f$var$load("aZoy2").then(()=>parcelRequire('StEha'));

});

parcelRegister("fUsH5", function(module, exports) {

let $b95257f9faf3b5e9$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $b95257f9faf3b5e9$var$load("gbDLp"),
    $b95257f9faf3b5e9$var$load("Nmd1P")
]).then(()=>parcelRequire('2olEk'));

});


//# sourceMappingURL=RecommendedSpaceBanner.8b91cb35.js.map
